export const INITIATIVES_STATUS = {
	FINISHED: 'Finished',
	IN_PROGRESS: 'In Progress',
	NEW: 'New',
	READY: 'Ready',
	TESTING: 'Testing'
};
